import qs from 'qs';

const EmailSignatureTemplate = {
    namespaced: true,

    state: {
        emailSignatureTemplateData: [],
    },

    getters: {
        emailSignatureTemplateData (state) {
            return state.emailSignatureTemplateData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['emailSignatureTemplateData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['emailSignatureTemplateData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['emailSignatureTemplateData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['emailSignatureTemplateData'] = state['emailSignatureTemplateData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по шаблонам
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getEmailSignatureTemplateData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index', // save т.к. нужен POST запрос для передачи данных в сервис
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.emailSignatureTemplate,
                    }),
                }).then(response => (
                    
                    commit('setArr', {
                        items: response.data
                    }),  
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Список шаблонов подписей email получен.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN emailSignatureTemplate.js | getEmailSignatureTemplateData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка получения шаблонов подписей email!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по шаблонам email 
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveEmailSignatureTemplateData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.emailSignatureTemplate
                    }),
                }).then(response => {

                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по уровням успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                        data.data.emailSignatureTemplateId = response.data[0].emailSignatureTemplateId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый уровень успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN emailSignatureTemplate.js | saveEmailSignatureTemplateData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление шаблона
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeEmailSignatureTemplateData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'emailSignatureTemplate/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Уровни успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении уровня!'),
                    console.log('ERROR IN emailSignatureTemplate.js | removeEmailSignatureTemplateData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default EmailSignatureTemplate;





// WEBPACK FOOTER //
// ./src/store/modules/emailSignatureTemplate.js